import { EmailDraftCard } from "@qw/ui";
import type { FC } from "react";
import { useDraft } from "@/providers/draft-provider";

import { DraftCardFooterExtras } from "./draft-card-footer";
import { DraftCardHeaderActions } from "./draft-card-header";
import { DraftContent } from "./draft-content";
import { DraftScheduledSendAlert } from "./draft-scheduled-send-alert";

export const DraftCard: FC = () => {
  const { draft, isScheduled } = useDraft();

  if (!draft) {
    return null;
  }

  return (
    <EmailDraftCard
      headerActions={<DraftCardHeaderActions />}
      aboveFooter={<DraftScheduledSendAlert />}
      footerExtras={<DraftCardFooterExtras />}
      showFooter={!isScheduled}
    >
      <DraftContent />
    </EmailDraftCard>
  );
};
